<template>
    <i class="icon" v-bind:class=iconClass></i>
</template>

<script>
  export default {
    name: 'Direction',
    props: {
      direction: String
    },
    computed: {
      iconClass: function () {return this.direction === 'roundtrip' ? 'icon-direction-forward' : 'icon-direction-roundtrip'}
    }
  }
</script>

<style scoped>
    i.icon {
        font-size: 2em;
        vertical-align: text-bottom;
    }
</style>